<template lang="pug">
  app-dialog.breakword(v-model="$_show" :header="dialogDocHeader")
    div Документ не имеет файла
    

</template>

<script>
import { AppDialogToggable } from "@/components"

export default {
  mixins: [AppDialogToggable],
  computed: {
    dialogDocHeader(){
      return 'Документ базы знаний' //+this.manageDoc.clause
    },

  },

  methods: {

    $_beforeShow (doc) {
      this.manageDoc = doc
    },
  },

  data () {
    return {
      manageDoc:{}
    }
  },
}
</script>